import { useCallback, useState } from "react"

import { toast } from "react-toastify"

import { useApiObservableHandler } from "./useApiObservableHandler"
import AuthFormProcessObservable from "../OrderResults/AuthForm"

interface SendAuthFormByEmailProps {
  emailAddress: string[]
  formFoxTestAN: number
  personId: number
  vendorId: number
  callback?: (response?: string) => void
}

interface UseAuthFormProcessEmailProps {
  showSuccess?: boolean
}

function useAuthFormProcessEmail({ showSuccess = true }: UseAuthFormProcessEmailProps = {}) {
  const [processing, setProcessing] = useState(false)
  const [response, setResponse] = useState("")

  const handleApi = useApiObservableHandler<string>()

  const handleOnSuccess = useCallback(
    (result: string, callback?: (result?: string) => void) => {
      if (showSuccess) {
        toast.success(result)
      }
      callback?.(result)
    },
    [showSuccess]
  )

  const sendAuthFormByEmail = useCallback(
    ({ emailAddress, formFoxTestAN, personId, vendorId, callback }: SendAuthFormByEmailProps) => {
      return handleApi({
        observableFactory: () =>
          AuthFormProcessObservable({
            EmailAddress: emailAddress,
            FormFoxTestAN: formFoxTestAN,
            PersonID: personId,
            VendorID: vendorId,
            SendToEmail: true,
            SendText: false,
          }),
        onSuccess: (result: string) => handleOnSuccess(result, callback),
        onLoadingChange: setProcessing,
        setResponse,
        defaultSuccessMessage: "Email sent successfully.",
      })
    },
    [handleApi, handleOnSuccess]
  )

  return {
    processing,
    response,
    sendAuthFormByEmail,
  }
}

export default useAuthFormProcessEmail
